import { defineStore } from 'pinia'
import qs from 'qs'
import { bridge } from '@/utils/bridge'
import type { brandCode, BridgeUserinfoModel } from '@gwm/bridge'
import defaultAvatar from '@/assets/avatar.png'
export const UserStore = defineStore('users', {
  state: () => {
    return {
      token: '',
      userInfo: { userId: '' } as BridgeUserinfoModel, //U942787758756331520
      sourceApp: 3 as brandCode,
      navHeight: 0 as Number,
      packet: '' as String, // 'web' | 'IOS' | 'Android',   IOS Android 只的是客户端中的设备
      defaultAvatar: defaultAvatar,
      postBrand: 'ora' as String,
      postScene: '0' as String, //是否开启浏览模式 1:开启  0:关闭
      appVersion: '' as String, // app版本号
      deviceId: '' as String, // app设备id
      goAppUrl: '' as String, // 跳转APP地址 分享后跳转打卡App 地址
    }
  },
  getters: {
    getToken: (state) => {
      return state.token
    },
    getUserInfo: (state) => {
      return state.userInfo
    },
    getNavHeight: (state) => {
      return state.navHeight
    },
    getPacket: (state) => {
      return state.packet
    },
    getPostBrand: (state) => {
      return state.postBrand
    },
    getPostScene: (state) => {
      return state.postScene
    },
    getGoAppUrl: (state) => {
      return state.goAppUrl
    },
  },
  actions: {
    setToken(token: string) {
      this.token = token
    },
    setUserInfo() {
      this.userInfo = bridge.userInfo() || {}
      console.log('this.userInfo')
      console.log(this.userInfo)
      this.token = this.userInfo.accessToken || ''
    },
    setSourceApp() {
      let sourceApp = bridge.brand
      if (!bridge.isApp) {
        // 非APP从链接拿品牌ID
        const params = qs.parse(window.location.search.replace(/^\?/, ''))
        sourceApp = (Number(params.source) as brandCode) || 1
      }
      this.sourceApp = sourceApp
    },
    resetToken() {
      this.token = ''
      this.userInfo = {} as BridgeUserinfoModel
    },
    setNavHeight() {
      this.navHeight = bridge.getStatusBarHeight()
      console.log('this.navHeight' + this.navHeight)
    },
    setPacket() {
      const ua = window.navigator.userAgent.toLowerCase()
      // console.log(ua)
      // const ua =
      //   'mozilla/5.0 (iphone; cpu iphone os 14_7_1 like mac os x) applewebkit/605.1.15 (khtml, like gecko) mobile/15e148 fromappios sapp cver=0.0.5 --------------ua'
      if (ua.indexOf('sapp') == -1) {
        this.packet = 'web'
      } else if (/android/.test(ua)) {
        this.packet = 'Android'
      } else if (/iphone|ipad|ipod/.test(ua)) {
        this.packet = 'IOS'
      }
      console.log(this.packet)
    },
    setPostBrand(postBrand: string) {
      this.postBrand = postBrand
    },
    setPostScene(postScene: string) {
      this.postScene = postScene
    },
    setAppVersion() {
      bridge.appVersion().then((res) => {
        this.appVersion = res || '1.1.0'
      })
    },
    setDeviceId() {
      if (bridge.platform === 'ios') {
        bridge.appInfoAsync().then((res: any) => {
          console.log(res, bridge.platform)
          this.deviceId = res.deviceID || ''
        })
      } else {
        const res: any = bridge.appInfo() || {}
        console.log(res, bridge.platform)
        this.deviceId = res.deviceID
      }
    },
    setGoAppUrl(goAppUrl: string) {
      this.goAppUrl = goAppUrl
    },
  },
  // persistence: {
  //   enable: true,
  //   option: [
  //     {
  //       key: 'SOTRE_USERS',
  //       states: ['token', 'sourceApp'],
  //     },
  //   ],
  // },
})
